import { createFileRoute } from '@tanstack/react-router'
import { lazy } from 'react'

import { assertDevelopmentBuild, DevPreviewUnavailable } from '@/spa/dev-only'

// The ternary is folded by Rollup in a production build, so the preview chunk
// is never emitted. See DevPreviewUnavailable in @/spa/dev-only.
const component = import.meta.env.DEV
  ? lazy(() => import('@/components/demo/sidebar-demo-page').then((m) => ({ default: m.SidebarDemoPage })))
  : DevPreviewUnavailable

export const Route = createFileRoute('/_bare/dev/sidebar-demo')({
  beforeLoad: assertDevelopmentBuild,
  component,
})
